import { type ComponentPropsWithoutRef, forwardRef } from "react"

type Props = Omit<ComponentPropsWithoutRef<"form">, "onSubmit"> & {
	onSubmit?(): void
}

const Form = forwardRef<HTMLFormElement, Props>(({ onSubmit, ...props }, ref) => (
	<form
		ref={ref}
		{...props}
		onSubmit={
			onSubmit
				? event => {
						event.preventDefault()
						onSubmit()
					}
				: undefined
		}
	/>
))

export default Form
